module.exports = __webpack_public_path__ + "img/File-ppt.b89cfd2f.svg";